
import { LOCATION_TYPES_EXETERNAL } from '../../domain-constants';
import { FIREARM_STORAGE_LOCATION_METADATA } from './firearm-storage-location.metadata';
import { FirearmStorageLocationBase } from './firearm-storage-location.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface FirearmStorageLocation extends FirearmStorageLocationBase {
}

export interface FirearmStorageLocationTransient { }

export class FirearmStorageLocation extends CrudEntity<FirearmStorageLocation, number, FirearmStorageLocationTransient> implements FirearmStorageLocationTransient {
  constructor(source?: Partial<FirearmStorageLocation>, options?: CrudEntityConstructionOptions<FirearmStorageLocation, number, FirearmStorageLocationTransient>) {
    super(FIREARM_STORAGE_LOCATION_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
    this.disposalLocation = this.disposalLocation || false;
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  get externalLocation(): boolean {
    return LOCATION_TYPES_EXETERNAL.includes(this.locationType);
  }
}





